import Vue from 'vue'
import Vuex from 'vuex'
import { getUserInfo, login,logoutApi } from '@/api/login'//登陆的接口
import assist from '@/utils/commonality' //公共的方法
import { getspQuest} from '@/api/upload' //封装的加密接口
Vue.use(Vuex)
 
// 用来存储数据
const state = {
    uid:assist.getCache('uid') || '',
    userInfo:assist.getCache('userinfo') || {},
    loginVisible:false,//全局控制登陆弹出层
    ispopvip:false ,//全局控制vip会员的弹出层
    datedetainment:false,//挽留弹窗的全局控制
    loading: false,//全局禁止点击的遮罩层
    sign:assist.getCache('sign') || '',//三方签名
    configforChannel:assist.getCache('configforChannel') ||  {},//客服一类的信息
    newconfig:assist.getCache('newconfig') || {},
    // 本次项目的
    wxiszfb:assist.getCache('whichpay') || 'wx',//微信还是支付宝
    ewmprice:assist.getCache('ewmprice') || {},//金额
    suceesswhat:assist.getCache('suceesswhat') || {completeTime:'',correct:''},//对了几个
    paysuccess:assist.getCache('paysuccess') || false,//支付成功
  }
// 响应组件中的事件
const actions = {
  async login(context, val) {//手机号登陆的逻辑
    try {
      // 登录并获取用户 UID  
      const loginResponse = await login(val);
      let  uid = loginResponse.data.uid
      let jwt  = loginResponse.data.jwt
      if (uid) {
           // 将 UID 存入 Vuex 状态
      context.commit('loginMutations', uid);
      assist.setCache('uid',uid) //本地存入uid
      assist.jwt.set(jwt) //本地存入jwt
      context.dispatch('getuserinfo') //通过uid调用获取用户信息
      return {success:true,data:loginResponse.data}
      }else {
        return {success:false,message:'登陆失败，未获取到用户UID'}
      }
    } catch (error) {
      console.error('登陆错误', error);
      return {success:false,error:error.message||'登陆过程中发生错误'}
    }
  },
 async logout(context,val) {//退出的
     try {
         await logoutApi()
         assist.clearCache('uid')
         assist.clearCache('userinfo')
         assist.jwt.clear();
         context.commit('updatelogout')
         assist.clearCache('sign')
         return {success:true}
     } catch (error) {
      console.error('退出错误', error);
      return {success:false,error:error.message||'请稍后重试'}
     }
    },
   async getuserinfo(context,val) { //通过uid拿到用户信息
        const userInfoResponse = await getUserInfo();
        context.commit('getUserInfo', userInfoResponse.data);//存入state
        assist.jwt.set(userInfoResponse.data.jwt);//本地存入jwt
        assist.setCache('userinfo', userInfoResponse.data, (new Date()).getTime() + 2700000);//存入用户信息
        context.dispatch('getSign',userInfoResponse) //调用获取签名的

    },
  async  getSign(context,val) {//获取签名
      let res =  await getspQuest('/api/cost/bySignInfo','post','17',{//拿到签名  类似于token
        token:val.data.jwt
      })
      assist.setCache('sign', res.data.sign); //本地存入签名
      context.commit('updateSign',res.data.sign) //修改state中的值
    },
    clickLoading({ commit },val) { //全屏开启禁止点击 element的
      commit('setLoading', val);
    },

  async  getconfigforChannel(context,val) { //获取客服链接 及 同意协议的一些配置
           try {
            let res =    await getspQuest(
              '/api/basic/getCfgForChannel',
              'get',
              '1'
            )

            if (res.data.ability.used.func.domain_name_change == 1) {
              let hostname = window.location.hostname.split(".");
              hostname.shift();
              hostname = hostname.join('.');
             const newconfig = await getspQuest(
               '/api/basic/getDomainBodyInfo',
               'get',
               '1',
               {
                 domain: hostname.length ==0 ?  'sanwubeixin.cn' : hostname, //localhost
               }
           )
           assist.setCache('newconfig', newconfig.data); //newconfig 存入本地
           context.commit('updatenewconfig', newconfig.data) //newconfig 修改state的值
         }



            assist.setCache('configforChannel', res.data); //存入本地
            context.commit('updateconfigforChannel', res.data) //修改state的值
           } catch (error) {
                console.log('获取配置信息出错');
           }
    },
    // 本次项目的

    async getewmprice (context,val) { //获取二维码和价格
      context.commit('updaewmprice', val)
    },

    async getpaysuccess(context,val) { //支付是否成功
      context.commit('updatepaysuccess', val)
    },

}
// 操作数据
const mutations = {
  loginMutations(state,val) { //修改uid的
    state.uid = val
  },
  getUserInfo(state,val) {//修改用户个人信息的
      state.userInfo = val
  },
  updateloginVisible(state,val) {//修改控制登陆弹出层的
      state.loginVisible = val
  },
  updatispopvip(state,val) {//修改控制vip弹出层的
    state.ispopvip = val
  },
  updatedetainment(state,val) {//修改挽留弹窗的弹出层
      state.datedetainment = val
  },
  updatelogout(state,val) {//退出
      state.userInfo = {}
      state.sign = ''
  },
  setLoading(state, loading) { //禁止点击的遮罩层
    state.loading = loading;
  },
  updateSign(state,val) {//修改三方签名
    state.sign = val
  },
  updateconfigforChannel(state,val) {//修改客服一类的信息
    state.configforChannel = val
  },
  updatenewconfig(state,val) {//修改客服一类的信息
    state.newconfig = val
  },
  // 本次项目的
  updatewxiszfb(state,val) {
    assist.setCache('whichpay',val)
    state.wxiszfb = val 
  },
  updaewmprice(state,val) {//修改价格
    assist.setCache('ewmprice',val)
    state.ewmprice = val
  },

  updatesuceesswhat(state,val) {
    assist.setCache('suceesswhat',val)
    state.suceesswhat = val
  },

  updatepaysuccess(state,val) {
    assist.setCache('paysuccess',val)
    state.paysuccess = val
  }


}
// 用来将state数据进行加工
const getters = {
    isuid:state => state.uid, //uid
    isloginVisible:state => state.loginVisible,//全局控制登陆弹出层的
    isispopvip : state => state.ispopvip,//全局控制会员弹出层的
    isuserInfo :state => state.userInfo,//用户的信息
    isdatedetainment:state => state.datedetainment,//全局控制挽留弹出层的
    isstorpclick: state => state.loading,//禁止点击的遮罩层loading
    issign :state => state.sign,//三方的签名类似于token，有些接口需要这个值
    isconfigforChannel:state => state.configforChannel,//客服的一些信息 用户同意协议什么的
    isnewconfig:state => state.newconfig,//新config
    // 本次项目的  
    iswxiszfb:state =>state.wxiszfb, //微信还是支付宝
    isewmprice:state => state.ewmprice, //二维码和金额
    issuceesswhat:state => state.suceesswhat, //对了几个
    ispaysuccess:state => state.paysuccess,//支付是否成功
  }
// 新建并暴露store
export default new Vuex.Store({
    state,
    actions,
    mutations,
    getters
})
 